import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const [status, setStatus] = useState({ isLoading: true, isAuthenticated: false });
    const location = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch('/api/auth/me', {
                    method: 'GET',
                    credentials: 'include',
                });

                if (response.ok) {
                    await response.json();
                    // Verificar se o usuário está logado E se o 2FA está ok se habilitado
                    // O cookie '2fa_authenticated' é gerado pelo servidor, mas vamos confiar na resposta do /home
                    // que só retorna 200 se a middleware isAuthenticated passar.
                    setStatus({ isLoading: false, isAuthenticated: true });
                } else {
                    setStatus({ isLoading: false, isAuthenticated: false });
                }
            } catch (error) {
                console.error('Erro ao verificar autenticação:', error);
                setStatus({ isLoading: false, isAuthenticated: false });
            }
        };

        checkAuth();
    }, [location.pathname]); // Re-verificar em mudanças de rota para maior segurança

    if (status.isLoading) {
        return (
            <div className="win-style" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                background: '#c0c0c0'
            }}>
                <div className="win-header" style={{ width: '200px', textAlign: 'center' }}>Segurança</div>
                <div className="win-body" style={{ padding: '20px' }}>Verificando acesso...</div>
            </div>
        );
    }

    if (!status.isAuthenticated) {
        // Redireciona para login, preservando a rota pretendida se necessário
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
